interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
  articleData?: {
    publishedTime?: string;
    modifiedTime?: string;
    author?: string;
    tags?: string[];
  };
  schemaData?: Record<string, unknown>;
}

export function generateSEOMeta(props: SEOHeadProps): string {
  const {
    title,
    description,
    keywords,
    canonicalUrl,
    ogType = 'website',
    ogImage,
    articleData,
    schemaData,
  } = props;

  const domain = 'https://bladder-health.example.com';
  const fullTitle = `${title} - 膀胱健康知识网`;

  const metaTags: Record<string, string> = {
    title: fullTitle,
    description,
  };

  if (keywords) {
    metaTags.keywords = keywords;
  }

  const linkTags: Record<string, string> = {};
  if (canonicalUrl) {
    linkTags.canonical = canonicalUrl.startsWith('http') ? canonicalUrl : `${domain}${canonicalUrl}`;
  }

  const ogTags: Record<string, string> = {
    'og:title': fullTitle,
    'og:description': description,
    'og:type': ogType,
    'og:url': canonicalUrl ? `${domain}${canonicalUrl}` : domain,
    'og:site_name': '膀胱健康知识网',
    'og:locale': 'zh_CN',
  };

  if (ogImage) {
    ogTags['og:image'] = ogImage;
    ogTags['og:image:width'] = '1200';
    ogTags['og:image:height'] = '630';
  }

  const twitterTags: Record<string, string> = {
    'twitter:card': 'summary_large_image',
    'twitter:title': fullTitle,
    'twitter:description': description,
  };

  if (ogImage) {
    twitterTags['twitter:image'] = ogImage;
  }

  const articleTags: Record<string, string> = {};
  if (articleData && ogType === 'article') {
    if (articleData.publishedTime) articleTags['article:published_time'] = articleData.publishedTime;
    if (articleData.modifiedTime) articleTags['article:modified_time'] = articleData.modifiedTime;
    if (articleData.author) articleTags['article:author'] = articleData.author;
    if (articleData.tags) {
      articleData.tags.forEach((tag, i) => {
        articleTags[`article:tag`] = tag;
      });
    }
  }

  const allTags = { ...metaTags, ...linkTags, ...ogTags, ...twitterTags, ...articleTags };

  return JSON.stringify(allTags);
}

export function generateSchemaOrg(schemaData: Record<string, unknown>): string {
  return JSON.stringify({
    '@context': 'https://schema.org',
    ...schemaData,
  });
}